const modalEditPhotoFormCompany = {
  title: 'Editar el logo de la empresa',
  typographyTrue: 'Registro de nueva empresa',
  typographyFalse: 'Información de la empresa'
};

export default modalEditPhotoFormCompany;
